import React, { useEffect, useState } from 'react';
import { setLoading } from '../store/CommonSlice';
import { getCountryAssetMasterDataList, saveInfo } from '../api/Services/masterServie';
import { CustomMessage } from '../const/Spinner';
import { enqueueSnackbar } from 'notistack';
import { DropdownChangeEvent } from 'primereact/dropdown';
import { CountryMaster, Entry } from '../types/assetTypes';
import { useDispatch, useSelector } from 'react-redux';
import { RootState } from '../store/Reduxstore';
import { PAGESEND, PAGESTART } from '../api/endpoint';



interface AssetStatusProps {
  setPathname: (path: string) => void;
}


const CountryForm : React.FC = () => {
 

  const [countries, setCurrentLocation] = useState<
      { label: string; value: number }[]
    >([]);
    const dispatch = useDispatch();

    useEffect(() => {
      if (countries.length === 0) getCurrentLocationList(1,PAGESEND);
    }, [countries]);

    const getCurrentLocationList = async (page: number, rows: number) => {
      dispatch(setLoading(true));
      try {
        const { data, status } = await getCountryAssetMasterDataList(page, rows,{currentLocationId:{value:"",matchMode: "startsWith"}});
        if (status.code === 200 && data?.length > 0) {
          const updatedData = data.map((val) => ({
            value: val.currentLocationId,
            label: val.countryName,
          }));
          updatedData.unshift({ label: "--Select--", value: 0 });
          setCurrentLocation(updatedData);
        } 
      } catch (error: any) {
        CustomMessage(error?.message, "error", enqueueSnackbar);
      } finally {
        dispatch(setLoading(false));
      }
    };

    const userDetails = useSelector((state: RootState) => state.auth)
        console.log(userDetails);

  // State to store the list of selected countries and texts
  const [entries, setEntries] = useState<Entry[]>([
    { noticeId: 0,
      currentLocationId: 0, 
      countryName: "", 
      info: '',
     userId: userDetails.userId ?? 0, }, // Initial entry
  ]);

  const handleAddEntry = () => {
    setEntries((prevEntries) => [
      ...prevEntries,
      {
        noticeId: 0,
        currentLocationId: 0,
        countryName: "",
        info: "",
        userId: userDetails.userId ?? 0,
      },
    ]);
  };
  // // Handle adding a new entry (country dropdown + text field)
  // const handleAddEntry = () => {
  //   setEntries([...entries, { noticeId: 0, currentLocationId: 0, countryName: '', info: '', userId: userDetails.userId ?? 0, }]);
    
  // };

  // const handleSubmit = async (event: React.FormEvent) => {
  //   event.preventDefault();
  
  //   if (entries.length === 0) {
  //     CustomMessage('No entries to submit.', 'warning', enqueueSnackbar);
  //     return;
  //   }
  
  //   dispatch(setLoading(true));
  
  //   try {
  //     for (const entry of entries) {
  //       const response = await saveInfo(entry);
  //       const { status } = response;
        
  //       if (status.code === 200 || status.code === 201) {
  //         CustomMessage(status.message, 'success', enqueueSnackbar);
  //       } else {
  //         CustomMessage(status.message, 'error', enqueueSnackbar);
  //       }
  //     }
      
  //     // After all submissions
     
  //   } catch (error: any) {
  //     CustomMessage(error?.message || 'An error occurred', 'error', enqueueSnackbar);
  //   } finally {
  //     dispatch(setLoading(false));
  //   }
  // };
  const handleSubmit = async (event: React.FormEvent) => {
  event.preventDefault();

  if (entries.length === 0) {
    CustomMessage('No entries to submit.', 'warning', enqueueSnackbar);
    return;
  }

  dispatch(setLoading(true));

  try {
    let allSuccessful = true; // Track if all are successful

    for (const entry of entries) {
      const response = await saveInfo(entry);
      const { status } = response;
      
      if (status.code === 200 || status.code === 201) {
        CustomMessage(status.message, 'success', enqueueSnackbar);
      } else {
        CustomMessage(status.message, 'error', enqueueSnackbar);
        allSuccessful = false;
      }
    }

    if (allSuccessful) {
      // ✅ After all successful submissions, reset entries
      setEntries([
        {
          noticeId: 0,
          currentLocationId: 0,
          countryName: "",
          info: "",
          userId: userDetails.userId ?? 0,
        }
      ]);
    }

  } catch (error: any) {
    CustomMessage(error?.message || 'An error occurred', 'error', enqueueSnackbar);
  } finally {
    dispatch(setLoading(false));
  }
};
  const handleSelectCountryChange = (
    e: React.ChangeEvent<HTMLSelectElement>,
    idField: keyof Entry, // 'currentLocationId'
    nameField: keyof Entry, // 'countryName'
    index: number
  ) => {
    const { value } = e.target;
    const selectedCountry = countries.find((country) => country.value === parseInt(value));
    
    setEntries((prevEntries) => {
      const updatedEntries = [...prevEntries];
      updatedEntries[index] = {
        ...updatedEntries[index],
        [idField]: parseInt(value),
        [nameField]: selectedCountry?.label || "",
      };
      return updatedEntries;
    });
  };
  
  const handleInputChange = (index: number, field: keyof Entry, value: string) => {
    setEntries((prevEntries) => {
      const updatedEntries = [...prevEntries];
      updatedEntries[index] = {
        ...updatedEntries[index],
        [field]: value,
      };
      return updatedEntries;
    });
  };

  const handleRemoveEntry = (index: number) => {
  setEntries((prevEntries) => prevEntries.filter((_, i) => i !== index));
};

  

 
  
  return (
    <div className="country-form-container">
      <style>
        {styles}
      </style>
      <h2>Select Country and Add Text</h2>
      <form onSubmit={handleSubmit}>
        {entries.map((entry, index) => (
          <div key={index} className="entry" style={{ position: "relative", padding: "20px", border: "1px solid #ccc", marginBottom: "15px", borderRadius: "8px" }}>
            {/* Cross (×) button for removing the entire entry box */}
            {entries.length > 1 && (
              <button
                type="button"
                onClick={() => handleRemoveEntry(index)}
                className="remove-button"
                style={{
                  position: "absolute",
                  top: "5px",
                  right: "5px",
                  background: "transparent",
                  border: "none",
                  fontSize: "20px",
                  cursor: "pointer",
                  color: "red",
                }}
              >
                &times; {/* This is × symbol */}
              </button>
            )}
  
            {/* Country select */}
            <select
              value={entry.currentLocationId}
              onChange={(e) => handleSelectCountryChange(e, 'currentLocationId', 'countryName', index)}
              required
            >
              <option value="">Select Country</option>
              {countries.map((country) => (
                <option key={country.label} value={country.value}>
                  {country.label}
                </option>
              ))}
            </select>
  
            {/* Info input */}
            <input
              type="text"
              value={entry.info}
              onChange={(e) => handleInputChange(index, 'info', e.target.value)}
              placeholder="Write some text"
              required
            />
          </div>
        ))}
  
        {/* Add Another Button */}
        <button type="button" onClick={handleAddEntry} className="add-button">
          Add Another
        </button>
  
        {/* Submit Button */}
        <button type="submit" className="submit-button">
          Submit
        </button>
      </form>
    </div>
  );
 };

export default CountryForm;

const styles = `
  /* Container Styling */
  .country-form-container {
    width: 100%;
    max-width: 600px;
    margin: 0 auto;
    padding: 20px;
    background-color: #f9f9f9;
    border-radius: 10px;
    box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
  }

  /* Heading Styling */
  .country-form-container h2 {
    text-align: center;
    color: #333;
    margin-bottom: 20px;
  }

  /* Form Styling */
  form {
    display: flex;
    flex-direction: column;
    gap: 15px;
  }

  /* Entry Field Styling */
  .entry {
    display: flex;
    flex-direction: column;
    gap: 10px;
  }

  /* Select and Input Styling */
  select, input {
    padding: 10px;
    font-size: 16px;
    border: 1px solid #ccc;
    border-radius: 5px;
    width: 100%;
    box-sizing: border-box;
  }

  /* Focus Effects */
  select:focus, input:focus {
    border-color: #007bff;
    outline: none;
  }

  /* Add Another Button Styling */
  .add-button {
    background-color: #007bff;
    color: white;
    border: none;
    padding: 10px;
    border-radius: 5px;
    cursor: pointer;
    font-size: 16px;
    width: 100%;
    transition: background-color 0.3s;
  }

  .add-button:hover {
    background-color: #0056b3;
  }

  /* Submit Button Styling */
  .submit-button {
    background-color: #28a745;
    color: white;
    border: none;
    padding: 12px;
    border-radius: 5px;
    cursor: pointer;
    font-size: 16px;
    width: 100%;
    transition: background-color 0.3s;
  }

  .submit-button:hover {
    background-color: #218838;
  }

  /* Responsive Design */
  @media (max-width: 600px) {
    .country-form-container {
      padding: 15px;
    }

    .entry {
      flex-direction: column;
    }

    select, input {
      font-size: 14px;
    }

    .add-button, .submit-button {
      font-size: 14px;
      padding: 10px;
    }
  }
`;
